<template>
  <RevCard
    class="flex items-center rounded-none py-20 shadow-none md:shadow-short md:rounded-lg md:px-24"
    :class="!scrollState.isScrolledDown ? 'space-x-16' : ''"
    :data-qa="
      orderline ? 'orderline-recap-block' : 'orderline-recap-block-loader'
    "
    data-test="orderline-recap-block"
  >
    <template v-if="orderline">
      <div :class="{ hidden: scrollState.isScrolledDown }">
        <RevIllustration
          alt=""
          :height="40"
          :src="orderline.product.image"
          :width="40"
        />
      </div>
      <div class="flex flex-1 flex-col text-left">
        <p class="body-2-bold">
          {{ orderline.product.title }}
        </p>

        <p class="caption" :class="{ hidden: scrollState.isScrolledDown }">
          {{ i18n(translations.orderNumber, { orderId: orderline.orderId }) }}
        </p>
      </div>
    </template>
    <template v-else>
      <div>
        <RevSkeleton height="40px" shape="rectangle" width="40px"></RevSkeleton>
      </div>
      <div class="flex flex-1 flex-col text-left">
        <RevSkeleton class="mb-8" height="12px" shape="line"></RevSkeleton>
        <RevSkeleton class="w-1/2" height="12px" shape="line"></RevSkeleton>
      </div>
    </template>
  </RevCard>
  <div v-if="error" class="text-static-default-low mt-16 flex">
    <IconInfo class="mr-8 shrink-0" size="20"></IconInfo>
    <p class="body-2">
      {{ i18n(translations.errorMessage) }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevSkeleton } from '@ds/components/Skeleton'
import { IconInfo } from '@ds/icons/IconInfo'

import { useOrderlineLightDetails } from '@/scopes/care-commons/components/order/OrderlineCard/composables/useOrderlineLightDetails'
import { useScrollState } from '~/scopes/customer-care/common/composables/useScrollState'

import translations from './OrderlineRecapBlock.translations'
import type { OrderlineRecapBlockProps } from './OrderlineRecapBlock.types'

const i18n = useI18n()
const { scope } = defineProps<OrderlineRecapBlockProps>()
const { scrollState } = useScrollState()
const { params } = useRoute()

const { data: orderline, error } = useOrderlineLightDetails(
  String(params.orderlineId),
  scope,
  {
    immediate: true,
  },
)
</script>
